import { Component, OnDestroy, OnInit } from '@angular/core';
import { CategoriesMenuItem, Category, Definition, DefinitionCategory } from '@emi/shared/models';
import { CategoryState, getFilterCategoryState } from '@emi/shared/state/filters';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { getCategories } from '@emi/shared/state/filters';
import {
    fetchCategoryDefinitions,
    HelpResourcesState,
    getHelpResourcesState,
    setIsLoading,
    getDefinitions,
} from '@emi/shared/state/help-resources';

@Component({
    selector: 'via-definitions',
    templateUrl: './definitions.component.html',
    styleUrls: ['./definitions.component.scss'],
})
export class DefinitionsComponent implements OnInit, OnDestroy {
    private stateSubscription: Subscription;
    private helpResourcesStateSubscription: Subscription;
    public stateCategories: Category[] = [];
    public categoryDefinitions: any;
    public categoryMenuItems: CategoriesMenuItem[] = [];
    public viaDefinitions: DefinitionCategory[] = [];
    public selectedDefinitions: any;
    public isLoading: boolean;
    public definitionCategories: DefinitionCategory[] = [];
    private TOP_ELEMENT_ID = 'top';

    constructor(private readonly store: Store<CategoryState>, private readonly helpResourcesStore: Store<HelpResourcesState>) {}

    public ngOnInit(): void {
        if (this.stateCategories.length === 0) {
            this.store.dispatch(getCategories());
        }

        this.helpResourcesStore.dispatch(getDefinitions());

        this.stateSubscription = this.store.pipe(select(getFilterCategoryState)).subscribe((state) => {
            this.stateCategories = state.categories;
            if (this.stateCategories.length > 0) {
                this.helpResourcesStore.dispatch(setIsLoading());
                this.helpResourcesStore.dispatch(
                    fetchCategoryDefinitions({ categoryId: state.categories[0].id, categoryTitle: state.categories[0].name })
                );
            }
            this.categoryMenuItems = this.mapToCategoriesMenuItems(this.stateCategories);
        });

        this.helpResourcesStateSubscription = this.helpResourcesStore.pipe(select(getHelpResourcesState)).subscribe((state) => {
            this.categoryDefinitions = state.categoryDefinitions;
            this.definitionCategories = state.definitions;
            this.mapDefinitions(state.definitions);
            this.isLoading = state.isLoading;
        });
    }

    public onViaDefinitionSelection(selectedDefinitionsId: number): void {
        this.selectedDefinitions = this.viaDefinitions.find((x) => x.id === selectedDefinitionsId);
        this.scrollToElement(this.TOP_ELEMENT_ID);
    }

    public onCategoriesDefinitionSelection(): void {
        if(this.categoryDefinitions != undefined)
        {
            this.selectedDefinitions = this.categoryDefinitions;
            this.scrollToElement(this.TOP_ELEMENT_ID);
        }
    }

    public onCategoryMenuItemSelection(item: CategoriesMenuItem): void {
        this.helpResourcesStore.dispatch(setIsLoading());
        this.helpResourcesStore.dispatch(fetchCategoryDefinitions({ categoryId: item.id, categoryTitle: item.name }));

        this.helpResourcesStateSubscription = this.helpResourcesStore.pipe(select(getHelpResourcesState)).subscribe((state) => {
            this.selectedDefinitions = state.categoryDefinitions;
            this.isLoading = state.isLoading;
        });
    }

    public scrollToElement(selector: string): void {
        const element = document.getElementById(selector);
        element?.scrollIntoView({ behavior: 'smooth' });
    }

    public ngOnDestroy(): void {
        this.stateSubscription.unsubscribe();
        this.helpResourcesStateSubscription.unsubscribe();
    }

    private mapDefinitions(definitions: DefinitionCategory[]) {
        this.viaDefinitions = [];
        for (let index = 0; index < definitions.length; index++) {
            const categoryDefinition = definitions[index];
            const subDefinitions = categoryDefinition.definitions.map(
                (subCategoryDefinition) =>
                    new Definition(subCategoryDefinition.id, subCategoryDefinition.title, subCategoryDefinition.description)
            );

            this.viaDefinitions.push(new DefinitionCategory(categoryDefinition.id, categoryDefinition.name, subDefinitions));
            this.selectedDefinitions = this.viaDefinitions[0];
        }
    }

    private mapToCategoriesMenuItems(categories: Category[]): CategoriesMenuItem[] {
        return categories.map((category) => new CategoriesMenuItem(category.id, category.name));
    }
}
